// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
const KEY_USERS_MANAGER="usersManager"

export default {
  list(id) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child(KEY_USERS_MANAGER)
        .orderByChild("id")
        .equalTo(id)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });

        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/manager/manager-history/manager-history-single/manager-history-single-service.js